<template>
    <div>
        <el-drawer
            title="添加推荐商品"
            :visible.sync="drawerShow"
            :wrapperClosable="true"
            :destroy-on-close="true"
            size="500px"
            @close="close"
        >
            <div class="drawer-content" v-loading="listLoading">
				<el-form :model="formData"  ref="formData" label-position="top" size="medium">
					<el-form-item label="添加推荐商品:">
					    <span slot="label">商品ID：<small class="from-tip"><span class="el-icon-warning"></span>填写商品ID，多个ID之间用逗号分隔</small></span>
					    <el-input placeholder="输入商品ID，搜索需要添加的商品" v-model="sGoodsIds">
					        <el-button slot="append" icon="el-icon-search" @click="searchGoods()">搜索商品</el-button>
					    </el-input>
					    <el-table class="MT10" :data="sGoodsList" size="mini" border stripe v-loading="sgoodsLoading">
					        <el-table-column prop="id" label="商品ID" width="90"></el-table-column>
					        <el-table-column prop="name" label="商品名称" show-overflow-tooltip></el-table-column>					        
					        <el-table-column label="操作" width="80">
					            <template slot-scope="scope">
					                <el-button type="text" @click="delGoods(scope.row.id)">删除</el-button>
					            </template>
					        </el-table-column>
					    </el-table>
					</el-form-item>					
				</el-form>
                
            </div>
            <div class="drawer-footer">
				<el-button @click="close()">取 消</el-button>
                <el-button type="primary" size="medium" @click="submitForm" :loading="btnLoading">确定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    data(){
        return{
            drawerShow: false,
            listLoading:false,
            data: null,
			sGoodsIds: "",
			sgoodsLoading: false,
			sGoodsList: [],
			formData:{},
			btnLoading:false
        }
    },
    methods:{
        close(){
			this.$refs.formData.resetFields();
			this.sGoodsIds = ''
			this.sGoodsList = []
            this.drawerShow = false
        },
        show(){
            this.searchGoods();
            this.drawerShow = true
        },
        //搜索商品
        searchGoods() {
            if (this.sGoodsIds) {
                this.sgoodsLoading = true;
        
                this.sGoodsIds = this.sGoodsIds.replace(/，/g, ',');
        
                let _sGoodsIds = this.sGoodsIds.split(',');
                _sGoodsIds.map((v, i) => _sGoodsIds[i] = parseInt(v));
        		
        		
        		this.$request({
        		    url: "/shop_good/goodsIdNameList",
        		    method: 'post',
        		    data: _sGoodsIds
        		})
        		    .then((res) => {
        		        const { state, msg, result } = res.data;
        		        if (result && result.length > 0) {
        		        	this.sgoodsLoading = false;
        		            result.map(item => {
        		                if (!this.sGoodsList.find(v => v.id == item.id)) {
        		                    this.sGoodsList.push(item)
        		                }
        		            })
        					
        		        } else {
							this.sGoodsIds = ''
        					this.sgoodsLoading = false;
        		            this.$message.error(msg || '没有找到相关商品');
        		        }
        		    })
        		    
        	}
        },
		delGoods(id) {
		    this.sGoodsList = this.sGoodsList.filter(v => v.id != id);
		},
		submitForm() {
		    this.$refs["formData"].validate((valid) => {
				if (valid) {
					var _goodsIds = [];					
					this.sGoodsList.map(item => {
					    if(!item.ids || item.ids.length < 1){
					        _goodsIds.push(item.id);
					    }
					})
					
					if( _goodsIds == ''){
						return this.$message.error("请先添加商品！");
					}
					this.btnLoading = true;					
					this.$request({
						url: "/good/recommend/addRecommend",
						method: "POST",
						data: {ids:_goodsIds}
					})
						.then((res) => {
							//处理成功回调
							const { state, msg } = res.data;
							if (state && state == 1) {
								this.$message.success("添加成功");
								this.$emit('onUpdate');
								this.close();
							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.btnLoading = false;
						});
				}
		    });
		},
    }
}
</script>

<style lang="scss" scoped>

</style>